
import { useNavigate } from "react-router-dom";
import t from "../../../../service/translate.service";
import { Modal } from "antd";

const SuccessModal = (props) => {
  const navigate = useNavigate()

  return (
    <Modal
      open={true}
      closeIcon={false}
      closable={false}
      footer={[
        <button
          className="button primary small"
          key="ok"
          onClick={() => navigate('/')}
          aria-label={t.CLOSE_SUCCESS}
        >
          {t.CONSULTATIONS_OK}
        </button>
      ]}
      aria-labelledby="successModalTitle"
      role="dialog"
      aria-live="assertive"
    >
      <div className="modal-body-wrapper">
        <p className="modal-p" id="successModalTitle" aria-live="assertive" role='alert'>
          {`
            ${t.CONSULTATIONS_SUCCESS_MESSAGE_1}
            ${props.date}
            ${t.CONSULTATIONS_SUCCESS_MESSAGE_2}
            ${props.time}
            ${t.CONSULTATIONS_SUCCESS_MESSAGE_3}
          `}
        </p>
      </div>
    </Modal>
  );
};

export default SuccessModal;
